import { createSelector, createStructuredSelector } from 'reselect';
import { get } from 'lodash/fp';

import stringifyAdsQuery from 'components/searchAds/stringifyAdsQuery';
import parseAdsSearch from 'components/searchAds/parseAdsSearch';

const getQueryFromUrl = createSelector(
  get(['location', 'search']),
  parseAdsSearch,
);

const getPageLink = createSelector(
  getQueryFromUrl,
  get(['eventKey']),
  get(['location', 'pathname']),
  (query, eventKey, pathname) => {
    if (!eventKey) {
      return;
    }

    const search = stringifyAdsQuery({
      ...query,
      page: eventKey === 1 ? undefined : eventKey,
    });

    return `${pathname}${search}`;
  },
);

export default createStructuredSelector({
  pageLink: getPageLink,
});
